import React, { FC, useContext } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Text } from "@fluentui/react-components";

import { IRapComponentProperties, RapComponentContext } from "../../platform/Layout";
import { IUhfViewState } from "../../pages/Contracts";
import { LinkConfigurator } from "./components/LinkConfigurator/LinkConfigurator";
import { TestConfigurator } from "./components/TestConfigurator/TestConfigurator";
import { UHFPreview } from "./components/UHFPreview/UHFPreview";
import { Banner } from "../../common/components/Banner/Banner";

import "./TestView.scss";
import { localizedStrings } from "../../common/localization/LocalizedStrings";

//Props passed by parent component
interface ITestViewProvidedProps extends IRapComponentProperties {
    alpineTest?: boolean;
}

interface ITestViewOwnProps {}

export type ITestViewProps = ConnectedProps<typeof connector> & ITestViewProvidedProps;

const TestViewInitializer: FC<ITestViewProps> = props => {
    const context = useContext(RapComponentContext);
    return (
        <div className="c-testContainer">
            <Banner/>
            <div className="c-controlContainer">
                <Text size={900}>{localizedStrings.TestView?.TestConfigurator?.title}</Text>
                <Text block>{localizedStrings.TestView?.TestConfigurator?.description}</Text>
                <LinkConfigurator/>
                <TestConfigurator/>
            </div>
            <div className="c-previewContainer">
                <UHFPreview alpineTest={props.alpineTest}/>
            </div>
        </div>
    );
};

function mapStateToProps(state: IUhfViewState, providedProps: ITestViewProvidedProps): Partial<ITestViewOwnProps> {
    return {
        ...providedProps
    };
}

// Hook up action creators to reducer
const ActionsToDispatch = {
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const TestView = connector(TestViewInitializer);